<ng-container *ngIf="item; else skeleton">
  <div (click)="onClickItem(); $event.preventDefault()">
    <div class="item-box" [class.inactivated]="loading" [style.padding-top]="100 / ratio + '%'">
      @if (hasFavorite && logined) {
        <div
          class="icon-heart"
          [class.active]="item.isFavorite"
          (click)="onLikeClick(item); $event.stopPropagation()"
        ></div>
      }
      <div class="item-con">
        <!-- loading的时候 -->
        <div class="loading skeleton-loading" *ngIf="loading"></div>
        <!-- 图片 -->
        <app-lazy-image
          [lazy]="isProvider ? [item['dayLogo'], item['nightLogo']] : item['webLogo']"
          [defaultImg]="defaultImg()"
        ></app-lazy-image>
        <!-- 信息遮罩-->
        <div class="game-name" *ngIf="item.gameName">
          <span>{{ item.gameName }}</span>
        </div>
      </div>
    </div>
  </div>
  @if (isGameUnit) {
    <div class="rtp-info">
      <span>RTP </span>
      <span class="rtp-color">
        {{ item.returnToPlayer === null ? '-' : (item.returnToPlayer ?? 100 - item.bankerAdvantage) + '%' }}
      </span>
    </div>
  }
</ng-container>
<ng-template #skeleton>
  <div class="item-box skeleton-loading" [style.padding-top]="100 / ratio + '%'"></div>
</ng-template>
